<template>
    <nav v-if="numPages > 1" aria-label="Pagination" class="flex flex-wrap justify-center gap-1.5 py-8 sm:py-10 md:py-12 lg:py-13">
        <RouterLink v-if="currentPage > 1" :to="pageLink(currentPage - 1)" class="bg-gold-lighter hover:bg-gold flex size-9 items-center justify-center rounded-full transition-colors">
            <ArrowRightIcon class="w-4 rotate-180" />
            <span class="sr-only">Previous Page</span>
        </RouterLink>

        <template v-for="n in numPages" :key="`restaurants-list-page-${n}`">
            <span v-if="n == currentPage" aria-current="page" class="bg-primary flex size-9 items-center justify-center rounded-full text-white">{{ n }}</span>
            <RouterLink v-else :to="pageLink(n)" class="bg-gold-lighter hover:bg-gold flex size-9 items-center justify-center rounded-full transition-colors">{{ n }}</RouterLink>
        </template>

        <RouterLink v-if="currentPage < numPages" :to="pageLink(currentPage + 1)" class="bg-gold-lighter hover:bg-gold flex size-9 items-center justify-center rounded-full transition-colors">
            <ArrowRightIcon class="w-4" />
            <span class="sr-only">Next Page</span>
        </RouterLink>
    </nav>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { useRestaurantsListStore } from '../../stores/restaurant-list-store';
import ArrowRightIcon from '../../../images/icons/arrow-right.svg';
import { RouterLink, useRoute } from 'vue-router';

const store = useRestaurantsListStore();
const route = useRoute();

const { numPages, currentPage } = storeToRefs(store);

/**
 * Generate a page link.
 *
 * @param   {number} page The page to link to.
 * @returns {string}      The page router link target.
 */
function pageLink(page) {
    let link = '/restaurants/';

    if (route.params.concept) {
        link += route.params.concept + '/';
    }

    return link + page;
}
</script>
